import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text, Tooltip } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

// A stub stands in for a branch option that does not lead to a page yet (a
// connected option draws an edge to its page instead), so it is styled as a
// warning: a viewer who chooses that option has nowhere to go.
const AMBER = '#d97706';

function BranchStubNode({ data, selected }: NodeProps) {
  return (
    <div>
      <Tooltip
        label={`"${data.branchLabel || 'Unnamed'}" isn't connected to a page. Viewers who choose it will be stuck. Drag a page here or pick one in the element's settings.`}
        position="top"
        withArrow
        multiline
        w={240}
      >
        <Box
          className="branch-stub-dropzone"
          data-stub-id={data.parentId}
          data-branch-type={data.branchType}
          data-branch-index={data.branchIndex}
          style={{
            background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
            border: `2px dashed ${selected ? '#6366f1' : AMBER}`,
            borderRadius: '6px',
            padding: '8px 12px',
            minWidth: '120px',
            maxWidth: '140px',
            boxShadow: selected ? '0 4px 12px rgba(99, 102, 241, 0.2)' : '0 2px 6px rgba(0, 0, 0, 0.08)',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
        >
          <Handle type="target" position={Position.Top} />
          <Box style={{ textAlign: 'center' }}>
            <Box
              style={{
                background: AMBER,
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 6px',
              }}
            >
              <IconPlus size={14} color="white" />
            </Box>
            <Text size="10px" fw={600} mb={2} style={{ lineHeight: '1.2', color: AMBER }}>
              NOT CONNECTED
            </Text>
            <Text size="xs" fw={600} lineClamp={1} c="gray.7" style={{ fontSize: '11px' }}>
              {data.branchLabel || 'Unnamed'}
            </Text>
          </Box>
          <Handle type="source" position={Position.Bottom} style={{ opacity: 0 }} />
        </Box>
      </Tooltip>
    </div>
  );
}

export default memo(BranchStubNode);
